export type KeyDateKey = 'reg_opens' | 'reg_closes' | 'event_starts' | 'event_ends';
export type KeyDateStep = {
  key: KeyDateKey;
  group: 'entries' | 'event';
  iso: string;
  status: 'past' | 'current' | 'future';
};

type KeyDateEvent = {
  start_date: string;
  end_date: string;
  registration_opens?: string | null;
  registration_closes?: string | null;
};

/** The event's milestones in order, and the one the page is currently waiting on. */
export function buildKeyDates(event: KeyDateEvent, now: Date): KeyDateStep[] {
  const entries: Array<{ key: KeyDateKey; group: KeyDateStep['group']; iso: string }> = [];
  if (event.registration_opens)
    entries.push({ key: 'reg_opens', group: 'entries', iso: event.registration_opens });
  if (event.registration_closes)
    entries.push({ key: 'reg_closes', group: 'entries', iso: event.registration_closes });
  entries.push({ key: 'event_starts', group: 'event', iso: event.start_date });
  entries.push({ key: 'event_ends', group: 'event', iso: event.end_date });

  const starts = new Date(event.start_date);
  const ends = new Date(event.end_date);
  const regOpens = event.registration_opens ? new Date(event.registration_opens) : null;
  const regCloses = event.registration_closes ? new Date(event.registration_closes) : null;

  let currentKey: KeyDateKey;
  if (now >= ends) currentKey = 'event_ends';
  else if (now >= starts) currentKey = 'event_starts';
  else if (regCloses && now >= regCloses) currentKey = 'event_starts';
  else if (regOpens && now >= regOpens) currentKey = regCloses ? 'reg_closes' : 'event_starts';
  else if (regOpens) currentKey = 'reg_opens';
  else currentKey = 'event_starts';

  return entries.map((e) => ({
    ...e,
    status: e.key === currentKey ? 'current' : new Date(e.iso) <= now ? 'past' : 'future',
  }));
}
